<template>
  <div class="app-main-inner">
    <el-dialog
      :visible="visible"
      :title="$t('CargoMsg.Cargo_InvoiceChargeItemSetup')"
      width="520px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      top="5vh"
      custom-class="invoice-charge-item-popup"
      @open="showDialog"
    >
      <div class="app-main-inner-row" style="padding-top: 0;">
        <div class="triggers">
          <el-button type="primary" no="toAdd" @click="toAdd">{{ $t('common.btn.new') }}</el-button>
          <el-button type="primary" no="toEdit" :disabled="isEditing" @click="toEdit">{{ $t('common.btn.edit') }}</el-button>
          <el-button type="danger" no="toDelete" :disabled="isEditing" @click="toDelete">{{ $t('common.btn.delete') }}</el-button>
        </div>
      </div>
      <div class="app-main-inner-row row-grid" style="height: 360px;padding-left: 10px;padding-right: 6px;">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-params="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          style="width: 100%;flex:1"
          @gridReady="params=>gridApi=params.api"
        />
      </div>
      <div slot="footer" style="height: 25px;">
        <span style="position: absolute; right: 0; padding-right: 10px;">
          <el-button type="primary" no="toSave" :disabled="!needSave" @click="toSave">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
          <el-button style="width: 65px;margin-left: 5px;" no="cancel" @click="onCancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor/index'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import StrUtils from '@/utils/StrUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import { queryInvoiceChargeItem, saveInvoiceChargeItem, deleteInvoiceChargeItem } from '@/api/clearing/invoiceChargeItem'
import { chargeItemCompatibleLanguage } from '@/utils/commonUtil'

export default {
  name: 'InvoiceChargeItemWindow',
  components: {},
  props: {
    visible: { type: Boolean, required: true },
    invoiceType: { type: Number, required: true } // 发票类型
  },
  data() {
    return {
      changeFlag: false,
      InvoiceChargeItemList: [],
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        singleClickEdit: true,
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          filter: false
        },
        frameworkComponents: {
          CargoAgGridAdvanceSelectEditor,
          CargoAgGridCommonInputEditor
        }
      },
      gridApi: null,
      isEditing: false, // 是否编辑
      needSave: false, // 是否需要保存
      chargeItemSet: new Set()
    }
  },
  computed: {
    editable() {
      return this.isEditing
    },
    // 列表
    rowData() {
      let rowData = this.InvoiceChargeItemList
      if (!rowData || rowData.length === 0) {
        rowData = []
      } else {
        rowData = rowData.filter(p => p.invoiceType === this.invoiceType)
      }
      return rowData
    },
    columnDefs() {
      return [
        {
          headerName: ' ', maxWidth: 30, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ChargeItemId'), colId: 'chargeItemId', field: 'chargeItemId', initialWidth: 180, minWidth: 180, lockVisible: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => ({
            selectProps: {
              staticOptions: [...this.chargeItemSet],
              tagValue: 'itemId',
              tagName: this.language ? 'zhName' : 'enName',
              filterable: true,
              filterTagNames: ['chargecode', 'enName', 'zhName', 'cnShortName', 'scaleCode', 'languageName'],
              filterType: 'global',
              customLabel: (item) => this.language ? `${item.zhName}[${item.enName}]` : `${item.enName}[${item.zhName}]`,
              showCustomLabelInOption: true
            }
          }),
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ChargeItemName'), colId: 'chargeItemName', field: 'chargeItemName', initialWidth: 240, minWidth: 240,
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: false
          },
          onCellValueChanged: p => this.onCellChange(p)
        }
      ]
    }
  },
  watch: {
    invoiceType: {
      immediate: false,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) this.changeFlag = true
      }
    }
  },
  mounted() {
    this.loadList()
  },
  methods: {
    showDialog() {
      // if (this.changeFlag) {
      //   this.changeFlag = false
      //   this.loadList()
      // }
    },
    loadList() {
      this.InvoiceChargeItemList = []
      this.loading = getLoading()
      queryInvoiceChargeItem({ 'officeId': this.$store.getters.currentOfficeId }).then(res => {
        this.InvoiceChargeItemList = res.data
      }).finally(() => {
        this.loading.close()
      })
      this.initChargeItemSet()
    },
    initChargeItemSet() {
      const results = chargeItemCompatibleLanguage()
      this.chargeItemSet = new Set(results)
    },
    toAdd() {
      this.isEditing = true
      this.needSave = true
      const row = {}
      // 分公司
      row.officeId = this.$store.getters.currentOfficeId
      // 发票类型
      row.invoiceType = this.invoiceType
      row.chargeItemId = 0
      row.chargeItemName = ''
      // 序号
      row.serialNumber = this.InvoiceChargeItemList.length + 1
      this.InvoiceChargeItemList.push(row)
      this.$nextTick(() => {
        this.gridApi.deselectAll()
        const nodes = this.gridApi.getRenderedNodes()
        const lastNode = nodes[nodes.length - 1]
        lastNode.setSelected(true)
      })
    },
    toEdit() {
      this.isEditing = true
      this.needSave = true
    },
    toDelete() {
      const rows = this.gridOptions.api.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      //
      const self = this
      self.$confirm(this.$t('CargoMsg.Cargo_ConfirmCancellationOfRecord'), this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        type: 'warning'
      }).then(() => {
        self.loading = getLoading()
        deleteInvoiceChargeItem(rows).then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
          self.InvoiceChargeItemList = res.data
          //
          this.isEditing = false
          this.needSave = false
        }).finally(() => {
          self.loading.close()
        })
      }).catch(() => {
        //
      })
    },
    toSave() {
      if (this.InvoiceChargeItemList.length > 0) {
        const InvoiceChargeItemList = this.InvoiceChargeItemList
        for (const item of InvoiceChargeItemList) {
          if (item.invoiceType === '') {
            this.$message.warning(this.$t('CargoMsg.Cargo_RecordsWithEmptyInvoiceTypeExist'))
            return
          }
          // 非空
          if (!item.chargeItemId) {
            this.$message.warning(this.$t('CargoMsg.Cargo_ChargeItemId') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
            return
          }
          if (StrUtils.isEmpty(item.chargeItemName)) {
            this.$message.warning(this.$t('CargoMsg.Cargo_ChargeItemName') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
            return
          }
          // 重复维护
          let bExist = false
          for (const item2 of InvoiceChargeItemList) {
            if (item.uuid !== item2.uuid && item.invoiceType === item2.invoiceType && item.chargeItemId === item2.chargeItemId) {
              bExist = true
              break
            }
            // 都是新增的
            if (item.invoiceType === item2.invoiceType && StrUtils.isEmpty(item.uuid) && StrUtils.isEmpty(item2.uuid) && item !== item2 && item.chargeItemId === item2.chargeItemId) {
              bExist = true
              break
            }
          }
          if (bExist) {
            const itemName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', item.chargeItemId, 'zhName')
            this.$message.warning(itemName + this.$t('CargoMsg.Cargo_CanNotRepeat'))
            return
          }
        }
        this.loading = getLoading()
        saveInvoiceChargeItem(this.InvoiceChargeItemList).then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
          this.InvoiceChargeItemList = res.data
          //
          this.isEditing = false
          this.needSave = false
        }).finally(() => {
          this.loading.close()
        })
      }
    },
    onCancel() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
.invoice-charge-item-popup {
  .el-dialog__body {
    padding: 10px !important;
  }
}
</style>
